import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Alert from "../components/Alert";
import Aside from "../components/Aside";
import GoBackButton from "../components/goBackButton";
import { countries, countryKeys } from "../countries";
import styles from "../Identity-management-individual/style.module.css";
import styles1 from "./style.module.css";

function titleCase(str) {
	return str.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase());
}

const CorporateInformation = () => {
	const history = useHistory();
	const { state: locationState } = useLocation();
	const userInfo = JSON.parse(localStorage.getItem("user_info"));

	//Corporate
	const [TIN, setTIN] = useState(
		locationState?.view || locationState?.edit
			? locationState?.TIN || ""
			: userInfo?.account_type === "corporate"
				? userInfo?.tin
				: ""
	);
	// const [checkingTINRecord, setCheckingTINRecord] = useState(false);
	const [tinError, setTinError] = useState("");
	// const [taxpayerTINRecord, setTaxpayerTINRecord] = useState(null);
	const [organisationName, setOrganisationName] = useState(
		locationState?.view || locationState?.edit
			? locationState?.OrgName
			: userInfo?.corpname
	);
	const [accountManagers, setAccountManagers] = useState([]);
	const [accountManager, setAccountManager] = useState(
		locationState?.view || locationState?.edit
			? {
					name: locationState?.AcctMgrFullName,
					id: locationState?.AccountManagerId
				}
			: ""
	);
	const [address, setAddress] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Office_Address
			: ""
	);
	const [LGAs, setLGAs] = useState([]);
	const [LGA, setLGA] = useState(
		locationState?.view || locationState?.edit ? locationState?.Lga : ""
	);
	const [states, setStates] = useState([]);
	const [state, setState] = useState(
		locationState?.view || locationState?.edit
			? locationState?.State
			: "Enugu"
	);
	const [selectedStateCode, setSelectedStateCode] = useState(null);
	const [zones, setZones] = useState([]);
	const [zone, setZone] = useState(
		locationState?.view || locationState?.edit ? locationState?.Zone : ""
	);
	const [cities, setCities] = useState([]);
	const [city, setCity] = useState(
		locationState?.view || locationState?.edit ? locationState?.City : ""
	);
	const [country, setCountry] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Country || "Nigeria"
			: "Nigeria"
	);
	const [CAC, setCAC] = useState(
		locationState?.view || locationState?.edit
			? locationState?.RC_Number
			: ""
	);
	const [businessTypes, setBusinessTypes] = useState([]);
	const [typeOfBusiness, setTypeOfBusiness] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Economic_Sector
			: ""
	);
	const [categoryOfBusiness, setCategoryOfBusiness] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Business_Category
			: ""
	);
	const [orgEmail, setOrgEmail] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Email_Address
			: userInfo?.account_type === "corporate"
				? userInfo?.email
				: ""
	);
	const [contactNumber, setContactNumber] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Phone_Number
			: userInfo?.account_type === "corporate"
				? userInfo?.phonenumber
				: ""
	);
	const [ownerESBN, setOwnerESBN] = useState(
		locationState?.view || locationState?.edit
			? locationState?.Business_Owner_Anssid
			: ""
	);
	const [validatingOwnerESBN, setValidatingOwnerESBN] = useState(false);
	const [ownerESBNName, setOwnerESBNName] = useState("");
	const [submitting, setFetching] = useState(false);

	const [orgESBN, setOrgESBN] = useState(
		locationState?.view || locationState?.edit
			? locationState?.User?.Anssid
			: null
	);

	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	const getUserInfo = async () => {
		try {
			const info = await axios
				.get(`/auth/profile`)
				.then((res) => (res.data || {}).data);

			setOrgESBN(info.anssid);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response.data?.msg
				});
			}
		}
	};

	// const jtbChecks = async () => {
	// 	setCheckingTINRecord(true);
	// 	try {
	// 		await axios
	// 			.post("/txn/jtb/verifyBiz", {
	// 				tin: TIN,
	// 				userId: ""
	// 			})
	// 			.then((res) => {
	// 				const {
	// 					Taxpayer,
	// 					ResponseCode,
	// 					ResponseDescription,
	// 					JTBValidatedData: { chkEmail, chkFone, chkName }
	// 				} = res?.data;

	// 				if (ResponseCode === "005") {
	// 					setTinError("TIN " + ResponseDescription);
	// 					setAlert({
	// 						...alert,
	// 						showing: true,
	// 						type: "error",
	// 						message: `TIN ${ResponseDescription}. If FIRS TIN, continue. Else, please correct.`
	// 					});
	// 				} else if (ResponseCode === "001") {
	// 					setTinError("");
	// 					setTaxpayerTINRecord(Taxpayer);
	// 					if (!locationState?.view && !locationState?.edit) {
	// 						setOrganisationName(Taxpayer?.registered_name);
	// 						setOrgEmail(Taxpayer?.email);
	// 						setContactNumber(Taxpayer?.phone_no);
	// 						setCAC(Taxpayer?.registration_number);
	// 					}
	// 					if (
	// 						chkEmail !== "0" ||
	// 						chkFone !== "0" ||
	// 						chkName !== "0"
	// 					)
	// 						setAlert({
	// 							...alert,
	// 							showing: true,
	// 							type: "warning",
	// 							message:
	// 								"One or more fields have been modified, different from TIN records."
	// 						});
	// 					else
	// 						setAlert({
	// 							...alert,
	// 							showing: true,
	// 							type: "success",
	// 							message: "TIN record found"
	// 						});
	// 				}
	// 			});
	// 	} catch (err) {
	// 		let message = "";
	// 		if (err.response) {
	// 			message =
	// 				err.response.data.errors?.details[0].message ||
	// 				err.response.data?.error ||
	// 				err.response.data?.errors ||
	// 				err.response.data?.msg;
	// 		} else {
	// 			message = err.message;
	// 		}
	// 		setAlert({
	// 			...alert,
	// 			showing: true,
	// 			type: "error",
	// 			message:
	// 				message ||
	// 				"Something went wrong. Unable to submit your request."
	// 		});
	// 	} finally {
	// 		setCheckingTINRecord(false);
	// 	}
	// };

	const getLGAs = async () => {
		try {
			const info = await axios
				.get(`/settings/lga`)
				.then((res) => (res.data || {}).data);

			setLGAs(info);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response.data?.msg
				});
			}
		}
	};

	const getStates = async () => {
		try {
			const info = await axios
				.get(`/settings/state`)
				.then((res) => (res.data || {}).data);

			setStates(info);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response.data?.msg
				});
			}
		}
	};

	const getCities = async () => {
		try {
			const info = await axios
				.get(`/settings/locationsetup`)
				.then((res) => (res.data || {}).data);

			setCities(info);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response.data?.msg
				});
			}
		}
	};

	const getZones = async (LGACode) => {
		try {
			const info = await axios
				.get(`/zone/${LGACode}`)
				.then((res) => (res.data || {}).data);

			setZones(info);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response.data?.msg
				});
			}
		}
	};

	const getBusinessTypes = async () => {
		try {
			const info = await axios
				.get(`/settings/economicsector`)
				.then((res) => (res.data || {}).data);

			setBusinessTypes(info);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response.data?.msg
				});
			}
		}
	};

	const getAccountManagers = async () => {
		try {
			const info = await axios
				.get(`/admin/corporate-taxpayer/getallcoyacctmgrs`)
				.then((res) => (res.data || {}).data);

			setAccountManagers(info);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	};

	useEffect(() => {
		getStates();
		getLGAs();
		getCities();
		getBusinessTypes();

		getUserInfo();

		getAccountManagers();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const stateCode = states.find(
			(each) => each.Description === state
		)?.Code;

		setSelectedStateCode(stateCode);
	}, [state, states]);

	useEffect(() => {
		const selectedLGACode = LGAs.find(
			(each) => each.Description === LGA
		)?.Code;

		getZones(selectedLGACode);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [LGA, LGAs]);

	// useEffect(() => {
	// 	if (TIN?.length >= 10) jtbChecks();
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [TIN]);

	useEffect(() => {
		if (ownerESBN?.length >= 10) validateOwnerESBN();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ownerESBN]);

	// reset error state
	useEffect(() => {
		const delay = setTimeout(
			() =>
				setAlert({
					showing: false,
					type: null,
					message: ""
				}),
			7000
		);

		return () => clearTimeout(delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!!alert.showing]);

	const validateOwnerESBN = async () => {
		setValidatingOwnerESBN(true);
		setOwnerESBNName("");

		try {
			const res = await axios
				.get(`/users/anssid?anssid=${ownerESBN}`)
				.then((res) => (res.data || {}).data);

			if (res.accounttype !== "individual") {
				setAlert((prev) => ({
					...prev,
					showing: true,
					type: "error",
					message: "Enter a valid individual ESBN"
				}));
				setOwnerESBN("");
			} else {
				setOwnerESBNName(
					`${res.firstname} ${res.middlename} ${res.surname}`
				);
			}
		} catch (error) {
			setOwnerESBN("");
			setOwnerESBNName("");
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response.message ||
						error.response.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		} finally {
			setValidatingOwnerESBN(false);
		}
	};

	const generateESBN = async () => {
		try {
			if (orgESBN) return orgESBN;

			let query =
				userInfo?.account_type === "corporate"
					? `userId=${userInfo.id}`
					: `userId=${locationState.UserId}`;

			const lgaId = LGAs.find((each) => each.Description === LGA).Code;

			const res = await axios
				.post(`/system/generateuseranssid?${query}`, {
					lgaId,
					lgaCode: lgaId,
					lgaSerial: lgaId
				})
				.then((res) => (res.data || {}).data);

			if (userInfo.account_type === "corporate") {
				if (res.anssid && !userInfo.anssid) {
					localStorage.setItem(
						"user_info",
						JSON.stringify({ ...userInfo, anssid: res.anssid })
					);
				}
			}

			return res.anssid;
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.errors ||
						error.response.data?.error
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	};

	const submit = async (e) => {
		e.preventDefault();
		setFetching(true);

		if (tinError !== "") {
			setAlert({
				...alert,
				showing: true,
				type: "error",
				message: `TIN error: ${tinError}`
			});
		}

		try {
			const profileID = await axios
				.get("/getgeneralids/03")
				.then((res) => res.data.Id);

			const id = localStorage.getItem("id");

			const res = await axios
				.post(
					`/admin/individual-taxpayer/corporatesinglepagetin/${id}`,
					{
						tin: TIN,
						tinname: "",
						profile: profileID,
						org: organisationName,
						officeaddr: address,
						state,
						lga: LGA,
						city,
						zone,
						phone: contactNumber,
						email: orgEmail,
						rcnum: CAC,
						bizcategory: categoryOfBusiness,
						economicsector: typeOfBusiness,
						ownerESBN,
						inputter: orgEmail,
						authoriser: "",
						orgProfiles: []
					}
				)
				.then((res) => res.data);

			if (locationState?.edit) {
				setAlert({
					...alert,
					showing: true,
					type: "success",
					message: res.message
				});
			} else {
				generateESBN().then((ESBN) => {
					history.push("/CIM-success", ESBN);
				});
			}
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error?.message
				});
				console.error(error.message);
			}
		} finally {
			setFetching(false);
		}
	};

	const adminSubmit = async (e) => {
		e.preventDefault();
		setFetching(true);

		if (tinError !== "") {
			setAlert({
				...alert,
				showing: true,
				type: "error",
				message: `TIN error: ${tinError}`
			});
		}

		try {
			const profileID = await axios
				.get("/getgeneralids/03")
				.then((res) => res.data.Id);

			const res = await axios
				.post(`/admin/corporate-taxpayer/admincorporatesinglepagetin`, {
					tin: TIN,
					tinname: "",
					acctmgrId: accountManager?.id,
					profile: profileID,
					org: organisationName,
					officeaddr: address,
					state,
					lga: LGA,
					city,
					zone,
					phone: contactNumber,
					email: orgEmail,
					rcnum: CAC,
					bizcategory: categoryOfBusiness,
					economicsector: typeOfBusiness,
					ownerESBN,
					inputter: userInfo?.email,
					authoriser: "",
					orgProfiles: []
				})
				.then((res) => res.data);

			history.push("/CIM-success", res.anssid);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error?.message
				});
			}
		} finally {
			setFetching(false);
		}
	};

	const adminEdit = async (e) => {
		e.preventDefault();
		setFetching(true);

		if (tinError !== "") {
			setAlert({
				...alert,
				showing: true,
				type: "error",
				message: `TIN error: ${tinError}`
			});
		}

		try {
			const res = await axios
				.put(
					`/admin/corporate-taxpayer/editcoysinglepagetin/${locationState?.UserId}`,
					{
						tin: TIN,
						tinname: "",
						acctmgrId: accountManager?.id,
						profile: locationState?.ProfileId,
						org: organisationName,
						officeaddr: address,
						state,
						lga: LGA,
						city,
						zone,
						phone: contactNumber,
						email: orgEmail,
						rcnum: CAC,
						bizcategory: categoryOfBusiness,
						economicsector: typeOfBusiness,
						ownerESBN,
						inputter: userInfo?.email,
						authoriser: "",
						orgProfiles: []
					}
				)
				.then((res) => res.data);

			setAlert({
				...alert,
				showing: true,
				type: "success",
				message: res.message || res.msg
			});

			setTimeout(() => history.goBack(), 3000);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error?.message
				});
			}
		} finally {
			setFetching(false);
		}
	};

	return (
		<div className={styles.signup_page}>
			{alert.showing && <Alert text={alert.message} type={alert.type} />}
			<Aside />
			<main className={styles.auth__form__container}>
				{userInfo?.account_type !== "corporate" && <GoBackButton />}
				{locationState?.AcctMgrFullName && (
					<p className={styles1.account__manager}>
						Account Manager:{" "}
						<span>{locationState?.AcctMgrFullName}</span>
					</p>
				)}
				<h1>Corporate Information</h1>
				<div className={styles.body}>
					{!locationState?.view && (
						<p>
							Please fill in your correct details in ALL the
							fields on this screen and Click Sign Up to get your
							ESBN.
						</p>
					)}
					<form
						style={{ marginTop: "15px" }}
						className={styles.form}
						onSubmit={
							userInfo?.account_type === "corporate"
								? submit
								: locationState?.edit
									? adminEdit
									: adminSubmit
						}
					>
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="tin">
									Tax Identification Number (TIN){" "}
									{/* <span style={{ color: "red" }}>*</span> */}
								</label>
								<input
									id="tin"
									name="tin"
									type="text"
									placeholder="Input your TIN"
									onChange={(e) => {
										setTIN(e.target.value);
										if (!e.target.value && tinError)
											setTinError("");
									}}
									value={TIN}
									disabled={locationState?.view}
									// required
								/>
								{/* {checkingTINRecord && (
									<p
										style={{
											fontSize: "12px",
											margin: "-25px 0 0",
											color: "#9e9e9e"
										}}
									>
										checking record...
									</p>
								)} */}
							</div>
							<div>
								<label htmlFor="organisationName">
									Organisation Name{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									id="organisationName"
									name="organisationName"
									type="text"
									placeholder="enter..."
									onChange={(e) => {
										setOrganisationName(e.target.value);
									}}
									value={organisationName}
									required
									disabled={locationState?.view}
								/>
							</div>
						</div>
						<hr className={styles.hr} />
						{userInfo.account_type !== "corporate" && (
							<>
								<div className={styles.double__inputs}>
									<div>
										<label htmlFor="accountManager">
											Account Manager
										</label>
										<select
											id="accountManager"
											name="accountManager"
											onChange={(e) => {
												setAccountManager({
													id: e.target.value
												});
											}}
											value={accountManager?.id}
											disabled={locationState?.view}
										>
											<option value="">
												---Select Account Manager---
											</option>
											{accountManagers?.map((manager) => (
												<option
													key={manager?.id}
													value={manager.id}
												>
													{manager?.AcctMgrFullName}
												</option>
											))}
										</select>
									</div>
								</div>
								<hr className={styles.hr} />
							</>
						)}
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="orgEmail">
									Email{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									id="orgEmail"
									name="orgEmail"
									type="email"
									placeholder="enter..."
									onChange={(e) => {
										setOrgEmail(e.target.value);
									}}
									value={orgEmail}
									required
									disabled={
										locationState?.view ||
										locationState?.edit
									}
								/>
							</div>
							<div>
								<label htmlFor="contactNumber">
									Contact Number{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									id="contactNumber"
									name="contactNumber"
									type="tel"
									placeholder="enter..."
									onChange={(e) => {
										setContactNumber(e.target.value);
									}}
									value={contactNumber}
									pattern="^(?:0\d{10}|\+[1-9]\d{1,14})$"
									title="Please enter a valid phone number."
									minLength={11}
									required
									disabled={
										locationState?.view ||
										locationState?.edit
									}
								/>
							</div>
						</div>
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="ownerESBN">Owner's ESBN</label>
								<input
									id="ownerESBN"
									name="ownerESBN"
									type="number"
									placeholder="enter..."
									onChange={(e) => {
										setOwnerESBN(e.target.value);
										setOwnerESBNName("");
									}}
									value={ownerESBN}
									onBlur={(e) => {
										if (e.target.value.length < 10) {
											setAlert((prev) => ({
												...prev,
												showing: true,
												type: "error",
												message:
													"Enter a valid Owner's ESBN."
											}));
										}
									}}
									minLength={10}
									disabled={locationState?.view}
								/>
								{validatingOwnerESBN && (
									<p
										style={{
											fontSize: "12px",
											margin: "-25px 0 0",
											color: "#9e9e9e"
										}}
									>
										validating ESBN...
									</p>
								)}
								{ownerESBNName && (
									<p
										style={{
											fontSize: "12px",
											margin: "-25px 0 0",
											color: "#9e9e9e"
										}}
									>
										{ownerESBNName}
									</p>
								)}
							</div>
						</div>
						<hr className={styles.hr} />
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="categoryOfBusiness">
									Category of Business{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="categoryOfBusiness"
									name="categoryOfBusiness"
									onChange={(e) => {
										setCategoryOfBusiness(e.target.value);
									}}
									value={categoryOfBusiness}
									required
									disabled={locationState?.view}
								>
									<option value="">
										---Select Business Category---
									</option>
									<option>Sole Proprietor</option>
									<option>Partnership</option>
									<option>Limited Liability Company</option>
									<option>Public Liability Company</option>
									<option>Specialised Business</option>
								</select>
							</div>
							<div>
								<label htmlFor="typeOfBusiness">
									Type of Business{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="typeOfBusiness"
									name="typeOfBusiness"
									onChange={(e) => {
										setTypeOfBusiness(e.target.value);
									}}
									value={typeOfBusiness}
									required
									disabled={locationState?.view}
								>
									<option value="">
										---Select Type of Business---
									</option>
									{businessTypes.map((type) => (
										<option key={type.Description}>
											{type.Description}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="CAC">
									CAC{" "}
									{categoryOfBusiness ===
										"Limited Liability Company" && (
										<span style={{ color: "red" }}>*</span>
									)}
								</label>
								<input
									id="CAC"
									name="CAC"
									type="text"
									placeholder="enter..."
									onChange={(e) => {
										setCAC(e.target.value);
									}}
									// onBlur={(e) => {
									// 	if (
									// 		TIN &&
									// 		e.target.value !==
									// 			taxpayerTINRecord?.registration_number
									// 	)
									// 		setAlert({
									// 			...alert,
									// 			showing: true,
									// 			type: "warning",
									// 			message:
									// 				"Warning: CAC number entered is different from that on TIN record"
									// 		});
									// }}
									value={CAC}
									required={
										categoryOfBusiness ===
										"Limited Liability Company"
									}
									disabled={locationState?.view}
								/>
							</div>
						</div>
						<hr className={styles.hr} />
						<label htmlFor="address">
							Address <span style={{ color: "red" }}>*</span>
						</label>
						<input
							id="address"
							name="address"
							type="text"
							placeholder="enter..."
							onChange={(e) => {
								setAddress(e.target.value);
							}}
							value={address}
							required
							disabled={locationState?.view}
						/>
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="country">
									Country{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="country"
									name="country"
									onChange={(e) => {
										setCountry(e.target.value);
									}}
									value={country}
									required
									disabled={locationState?.view}
								>
									<option value="">
										---Select Country---
									</option>
									{countryKeys.map((key) => (
										<option
											value={countries[key].country}
											key={key}
										>
											{titleCase(
												countries[
													key
												].country.toLowerCase()
											)}
										</option>
									))}
								</select>
							</div>
							<div>
								<label htmlFor="state">
									State{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="state"
									name="state"
									onChange={(e) => {
										setState(e.target.value);
									}}
									value={state}
									required
									disabled={locationState?.view}
								>
									<option value="">---Select State---</option>
									{country === "Nigeria" ? (
										states?.map((state) => (
											<option key={state.Code}>
												{state.Description}
											</option>
										))
									) : (
										<option value="N/A">
											Not Applicable
										</option>
									)}
								</select>
							</div>
						</div>
						<div className={styles.double__inputs}>
							<div>
								<label htmlFor="LGA">
									LGA <span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="LGA"
									name="LGA"
									onChange={(e) => {
										setLGA(e.target.value);
									}}
									value={LGA}
									required
									disabled={locationState?.view}
								>
									<option value="">---Select LGA---</option>
									{country === "Nigeria" ? (
										LGAs?.filter(
											(each) =>
												each.StateCode ===
												selectedStateCode
										).map((LGA) => (
											<option key={LGA.Code}>
												{LGA.Description}
											</option>
										))
									) : (
										<option value="N/A">
											Not Applicable
										</option>
									)}
								</select>
							</div>
							{LGA && (
								<div>
									<label htmlFor="zone">
										Zone{" "}
										<span style={{ color: "red" }}>*</span>
									</label>
									<select
										id="zone"
										name="zone"
										onChange={(e) => {
											setZone(e.target.value);
										}}
										value={zone}
										required
										disabled={locationState?.view}
									>
										<option value="">
											---Select Zone---
										</option>
										{country === "Nigeria" &&
										state === "Enugu" ? (
											zones?.map((zone) => (
												<option key={zone.Description}>
													{zone.Description}
												</option>
											))
										) : country === "Nigeria" &&
										  state !== "Enugu" ? (
											<option>Non-Indigene</option>
										) : (
											<option value="N/A">
												Not Applicable
											</option>
										)}
									</select>
								</div>
							)}
						</div>
						{LGA && (
							<div className={styles.double__inputs}>
								<div>
									<label htmlFor="city">
										City{" "}
										<span style={{ color: "red" }}>*</span>
									</label>
									<select
										id="city"
										name="city"
										onChange={(e) => {
											setCity(e.target.value);
										}}
										value={city}
										required
										disabled={locationState?.view}
									>
										<option value="">
											---Select City---
										</option>
										{country === "Nigeria" &&
										state === "Enugu" ? (
											cities?.map((city) => (
												<option key={city.Code}>
													{city.Description}
												</option>
											))
										) : country === "Nigeria" &&
										  state !== "Enugu" ? (
											<option>Non-Indigene</option>
										) : (
											<option value="N/A">
												Not Applicable
											</option>
										)}
									</select>
								</div>
							</div>
						)}
						<hr className={styles.hr} />
						{!locationState?.view && (
							<div className={styles.btn__div}>
								<button
									type="button"
									className="secondary__btn"
									onClick={
										locationState?.view ||
										locationState?.edit
											? () =>
													history.push(
														"/statetin/corporate"
													)
											: () => history.push("/home")
									}
								>
									Cancel
								</button>
								<button
									type="submit"
									className="primary__btn"
									disabled={
										// !TIN ||
										(TIN && tinError) ||
										(TIN && TIN?.length < 10) ||
										validatingOwnerESBN ||
										!organisationName ||
										(ownerESBN && ownerESBN.length < 10) ||
										!address ||
										!zone ||
										!LGA ||
										!state ||
										!city ||
										!country ||
										!typeOfBusiness ||
										!categoryOfBusiness ||
										!orgEmail ||
										!contactNumber ||
										submitting
									}
								>
									{submitting ? "Submitting..." : "Submit"}
								</button>
							</div>
						)}
					</form>
				</div>
			</main>
		</div>
	);
};

export default CorporateInformation;
